// React Imports

import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
} from '@mui/x-data-grid';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import {
    Drawer,
    Stack,
} from "@mui/material";
import Typography from "@mui/material/Typography";

// App Imports
import {getUsageObligationData} from "../../../ExternalData/Usage/UsageClient";
import {changeObligationHierarchy} from "../obligationHierarchySlice";


// main function
export default function WorkIssuanceObligationUsageGrid() {

    // ****************** BEGIN STATES ****************************

    const [usageData, setUsageData] = useState([]);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCdpvId = useSelector((state) => state.obligationHierarchySlc.value.cdpvId);
    const selectorDataPointName = useSelector((state) => state.obligationHierarchySlc.value.dataPointName);
    const selectorDisplayAmount = useSelector((state) => state.obligationHierarchySlc.value.displayValue);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchUsageData = () =>
        getUsageObligationData(selectorCdpvId)

            .then(data => {
                console.log(data);
                // setDrilldownCDPVF(data);
                setUsageData(data);
                console.log("This is my data used for the grid rows...");
                console.log(usageData);
            })

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("My usage grid should have displayed...");
        fetchUsageData();
    }, [useSelector((state) => state.obligationHierarchySlc.value.usageGridOpen)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClose = () => {
        dispatchData(changeObligationHierarchy({usageGridOpen: false}));
    };


    function closeUsageDataDrawer() {
        dispatchData(changeObligationHierarchy({usageGridOpen: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchUsageData => [

        {    field: 'useStart',
            headerName: 'Start',
            description: '',
            sortable: false,
            width: 200,
            hide: false,
        },
        {    field: 'useEnd',
            headerName: 'End',
            description: '',
            sortable: false,
            width: 200,
            hide: false,
        },
        {    field: 'language',
            headerName: 'Language',
            description: '',
            sortable: false,
            width: 80,
            hide: false,
        },
        {    field: 'platformName',
            headerName: 'Platform',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'service',
            headerName: 'Service',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'platformTerritory',
            headerName: 'Territory',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },
        {    field: 'stakeholder',
            headerName: 'Stakeholder',
            description: '',
            sortable: false,
            width: 150,
            hide: false,
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },

    ];

    // *************** END COLUMNS *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarDensitySelector />
                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer sx={{height: "100%", width: 1000}}
                    anchor='right'
                    open={useSelector((state) => state.obligationHierarchySlc.value.usageGridOpen)}
                    onClose={closeUsageDataDrawer}
            >
                <Box>
                    <br/>
                    <h2 style={{paddingLeft: 19, cursor: 'pointer'}} onClick={() => handleClose()}>Usage Data</h2>
                    <br/>
                    < Stack direction="row" spacing={2}>
                        <Typography sx={{fontWeight: 'bold', pl: 3}}>Data Point</Typography>
                        <Typography>{selectorDataPointName}: {selectorDisplayAmount}</Typography>
                    </Stack>
                    <Box sx={{pl: 2}}>
                        <DataGridPro
                            style={{height: 600, width: 1000}}
                            aria-label={"UsageDataDrawerGrid"}
                            rows={usageData}
                            disableDensitySelector={true}
                            disableColumnSelector={true}
                            columns={columns(fetchUsageData)}
                            density={"compact"}
                            pageSize={20}
                            rowsPerPageOptions={[20]}
                            rowThreshold={0}
                            components={{
                                Toolbar: CustomToolbar,
                            }}

                        />
                    </Box>
                </Box>
            </Drawer>
        </div>
);

    // ****************** END RETURN ****************************


}



